import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDateForDisplay } from "../utils/dateFormat"; // adjust path as needed
const Course = ({ form }) => {
  const navigate = useNavigate();

  function toFixedDigitFloat(n, noOfDigit, noOfDigitAfterDecimal) {
    let [intPart, decimalPart] = n.toFixed(noOfDigitAfterDecimal).split("."); // Ensures decimal part has fixed digits
    intPart = intPart.padStart(noOfDigit, "0"); // Zero-pad the integer part
    return `${intPart}.${decimalPart}`;
}

  const handleCardClick = () => {
   if(form.type==='gst')
   {
    navigate(`/gstbilldetailsAdmin/${form._id}`); 
   }
   else if(form.type==='retail')
    {
      navigate(`/gstbilldetailsAdmin/${form._id}`); 
    }
    else if(form.type==='cashmemo')
      {
        navigate(`/gstbilldetailsAdmin/${form._id}`); 
      }
      else{
        navigate(`/notypebill/${form._id}`); 
      }
   
  };

  return (
    <div
  onClick={handleCardClick}
  className={`w-[180px] h-[170px] shadow-lg rounded-2xl p-4 flex flex-col justify-center cursor-pointer
    transform transition duration-300 hover:scale-105 hover:shadow-xl hover:bg-gradient-to-r from-blue-400 to-blue-200
    ${form.submission_status === "submitted" ? " bg-gradient-to-r from-green-400 to-green-200" : " bg-gradient-to-r from-pink-400 to-pink-200"}
  `}
>  
  <p className="w-full text-xs text-center mb-[10px]">{form.bill_number}</p>
  <p className="w-full text-xs text-center mb-[10px] font-semibold">{form.name.length <= 30 ? form.name : `${form.name.slice(0, 30)}...`}</p>
  <p className="w-full text-xs text-center font-bold mt-1">
     {form.submission_status.toLowerCase() === "submitted" ? "₹"+toFixedDigitFloat(form.total_amount,1,2) : ""}
  </p>
  <p className="w-full text-xs text-center font-semibold mt-1">
       {form.submission_status.toLowerCase() === "submitted" ? "Confirmed" : "Yet to Confirm"}
    </p>
    <p className="w-full text-xs text-center font-semibold mt">
       {form.submission_status.toLowerCase() === "submitted" ? formatDateForDisplay(form.issue_date) : formatDateForDisplay(form.issue_date)}
    </p>
</div>
  );
};

export default Course;
